import type { FC } from "react";

export const PartnerTimeline: FC = () => {
    const steps = [
        "Sign up as a developer",
        "Sign up for a trial store",
        "Build your integration",
        "Confirm developer details",
        "Register as a partner",
        "Submit for review",
        "Become a partner",
    ];

    return (
        <div
            className="grid gap-0 relative"
            style={{
                gridTemplateColumns: `repeat(${steps.length}, 1fr)`,
            }}
        >
            <div
                className="absolute top-4 left-0 right-0 bg-[var(--color-border-strong)] h-px"
            />
            {steps.map((step, index) => (
                <div
                    className="flex flex-col items-center text-center gap-2 relative"
                    key={index}
                >
                    <div
                        className={
                            "size-8 rounded-full border border-[var(--color-border-strong)] flex items-center " +
                            "justify-center bg-[var(--color-surface-raised)] text-sm font-bold"
                        }
                    >
                        {index + 1}
                    </div>
                    <span className="text-xs text-[var(--color-text-secondary)]">{step}</span>
                </div>
            ))}
        </div>
    );
};
